import { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { redirectSanitized } from '@features/auth/utils/redirect';
import { SiteLayout } from '@features/shared/ui/SiteLayout/SiteLayout';
import { SiteLogoWidget } from '@features/shared/ui/SiteLogo/SiteLogoWidget';

import { SessionEndedPage } from './SessionEndedPage';

type Props = {
  back?: string;
};

export function SessionEndedPageWidget({ back = '/' }: Props) {
  const { login, isAuthenticated } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (isAuthenticated) {
      redirectSanitized(router, back);
    }
  }, [isAuthenticated, router, back]);

  const handleContinue = () => {
    redirectSanitized(router, back);
  };

  return (
    <SiteLayout siteLogo={<SiteLogoWidget />}>
      <SessionEndedPage onContinue={handleContinue} onLogin={() => login(back)} />
    </SiteLayout>
  );
}
